import React from 'react'

import FormScreen from './formScreen'

class UpdatedAnswersScreen extends React.Component {
  render() {
    const options = [
      {
        label:
          'A new paper or abstract was published. (specify the paper below)',
        value: 'new',
      },
      {
        label: 'The answers are old',
        value: 'old',
      },
      {
        label: 'Other (specify below)',
        value: 'other',
      },
    ]

    return (
      <FormScreen
        subtitle="Please specify below why you're requesting updated answers."
        options={options}
        requestType="outdated"
        {...this.props}
      />
    )
  }
}

export default UpdatedAnswersScreen
